import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { PageNotFound } from '../../youwell-common/components';
import urls from '../../app/urls';
import Favourites from './Favourites';
import Videos from './Videos';
import Calendar from './Calendar/Index';
import ActivityDiary from './activityDiary/ActivityDiary';
import SleepDiary from './sleepDiary/Index';
import PrintFiles from './PrintFiles';
import ElementSummary from './ElementSummary';
import Feedback from './Feedback';
import Consent from './Consent';
import SingleTaskPage from '../singlepage/SingleTaskPage';

const Index = () => (
    <Switch>
        <Route path={urls.inside.pages.favourites} component={Favourites} />
        <Route path={urls.inside.pages.videos} component={Videos} />
        <Route path={urls.inside.pages.calendar} component={Calendar} />
        <Route path={urls.inside.pages.activityDiary} component={ActivityDiary} />
        <Route path={urls.inside.pages.sleepDiary} component={SleepDiary} />
        <Route path={urls.inside.pages.prints} component={PrintFiles} />
        <Route path={urls.inside.pages.feedback} component={Feedback} />
        <Route path={`${urls.inside.pages.consent}/:consentId?`} component={Consent} />
        <Route path={`${urls.inside.pages.elements}/:elementType?`} component={ElementSummary} />
        <Route path={`${urls.inside.pages.singlepage}/:taskId`} component={SingleTaskPage} />
        <Route component={PageNotFound} />
    </Switch>
);

export default Index;
